module.exports = __webpack_public_path__ + "img/IMG-20200508-WA0014.cd5ef836.jpg";